export const WALMART_TOOLBAR_TITLE = "Walmart";

// form
export const START_DATE_LABEL = "Start date";
export const END_DATE_LABEL = "End date";
export const MARKETPLACE_LABEL = "Marketplace";
export const ORDER_STATUS_LABEL = "Order status";

export const DATE_FORMAT = "yyyy-MM-dd";

export const WALMART_MARKETPLACE_COMPANY = "Walmart";

export const ORDER_STATUS_OPTIONS = [
    "Unshipped",
    "Shipped",
    "Canceled",
];

export const CANCEL = "Cancel";
export const SUBMIT = "Submit";

// table
export const WALMART_HEAD_CELLS = [
    { id: 'orderId', center: true, disablePadding: false, label: 'Order ID' },
    { id: 'purchaseOrderId', center: true, disablePadding: false, label: 'Walmart PO Number' },
    { id: 'orderStatus', center: true, disablePadding: false, label: 'Order Status' },
];

export const DEFAULT_SORT_BY_HEAD_CELL = "orderId";
export const NO_ORDERS_FOUND = "No orders found for the selected date range.";
export const TOTAL_ORDERS_FETCHED = "Total orders fetched";
